import React from 'react';
import { connect } from 'react-redux';
import { DBTextAreaObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ObservationGaitGaitDescription extends React.Component {

    render() {
        return (
            <div className={styles.textarea_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='Gait Description' />
                <label className={styles.textarea_label}>Gait Description</label>
                <DBTextAreaObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEOBS'
                    entityKeyColumn='OONO'
                    entityKeyValue={this.props.oono}
                    field='OOGAICOMMENTS'
                    className={styles.textarea}
                />
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let oono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEOBS)
        .find(key => (state.entities.notes.PTOBJECTIVEOBS[key].OOEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEOBS[key].OONTNO === pk && noteType !== 1)));

    return {
        noteId: noteId,
        oono: oono,
        flagged: state.entities.notes.PTOBJECTIVEOBS[oono].OOGAICOMMENTS ? true : false
    };
}

const connectedObservationGaitGaitDescription = connect(mapStateToProps)(ObservationGaitGaitDescription);
export { connectedObservationGaitGaitDescription as ObservationGaitGaitDescription };


